import './ExtraditionProducts.scss'

import { Alert, Image, Input, message, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import React from 'react'

import { useSiparisDetayQuery } from '../../gql/GeneratedGraphqlTypes'
import { ExtraditionProductsItem } from './types'

interface Props {
  siparis: string
}

const ExtraditionProducts = ({ siparis }: Props) => {
  const temp = parseInt(siparis)
  const [messageApi, contextHolder] = message.useMessage()
  const { data, error } = useSiparisDetayQuery({
    variables: { siparis_id: temp },
  })
  if (error) {
    messageApi.error(`${error}`, 2)
  }
  if (!data) {
    return null
  }
  const ReturnedProductsItems: ExtraditionProductsItem[] =
    data?.siparisDetay.satirlar
      ?.filter((urun) => urun?.durum === 'İade Talebi')
      .map((urun) => {
        return {
          key: urun?.id?.toString() || '',
          isim: urun?.urun.isim || '',
          aciklamalar: (urun?.urun as any).aciklamalar || '',
          iade_talep_adet: urun?.adet || 0,
          birim_fiyat: parseFloat(`${urun?.birim_fiyat} â‚º` ?? '0'),
          durum: urun?.durum || '',
          kargo_takip_no: urun?.kargo_takip_no || '',
          min_adet: urun?.min_adet || 0,
          kargo_fiyat: urun?.kargo_takip_no || '',
          images: (urun?.urun.resimler as string[]) || [],
        }
      }) || []

  const columns: ColumnsType<ExtraditionProductsItem> = [
    {
      title: 'Ürün Adı',
      dataIndex: 'isim',
      key: 'isim',
      align: 'center',
      render: (text: string, record: ExtraditionProductsItem) => (
        <div className="order-product-cell">
          <Image src={record.images?.[0] ?? ''} alt={text} className="order-product-image" width={72} height={72} />
          <div className="product-name-wrapper">
            <span>{text}</span>
            {record.aciklamalar && <span className="product-aciklama"><span className="aciklama-label">Açıklama:</span> {record.aciklamalar}</span>}
          </div>
        </div>
      ),
    },
    {
      title: 'İade Talep Adeti',
      dataIndex: '',
      key: 'iade_talep_adet',
      align: 'center',
      render: (record) => {
        return (
          <>
            <Input
              min={record.min_adet === 0 ? 1 : record.min_adet ?? 1}
              disabled={true}
              className="input-number quantity-number"
              value={record.iade_talep_adet!}
            />
          </>
        )
      },
    },
    {
      title: 'Fiyat',
      dataIndex: 'birim_fiyat',
      key: 'birim_fiyat',
      align: 'center',
    },
    {
      title: 'İade Durumu',
      dataIndex: 'durum',
      key: 'durum',
      align: 'center',
      render: (durum, record) => {
        if (durum === 'İade Talebi') {
          return <span>İadesi Yapıldı</span>
        }
      },
    },
    {
      title: 'Kargo Numarası',
      dataIndex: 'kargo_fiyat',
      key: 'kargo_fiyat',
      align: 'center',
    },
  ]
  return (
    <>
      {contextHolder}
      <div className="extradition-products">
        <Alert
          className="custom-alert"
          description="İadesi yapılan ürünleriniz listelenmektedir. "
          type="success"
          closable
        />
        <br />
        <div>
          <Table
            columns={columns}
            pagination={false}
            dataSource={ReturnedProductsItems}
            bordered={true}
            className="custom-table"
          />
        </div>
      </div>
    </>
  )
}

export default ExtraditionProducts

